import {
  makeRequest,
} from 'cityads-v3/utils/apiUtils';

import {
  amplitudeSendSmsError,

  ERROR_CODE_SMS_SEND_NETWORK_OR_SERVER_ERROR,
  ERROR_CODE_SMS_CODE_CHECK_NETWORK_OR_SERVER_ERROR,
} from 'cityads-v3/utils/counterUtils';

import {
  SMS_RESULT_PHONE_NOT_FOUND,

  SMS_STATE_IDLE,
} from 'cityads-v3/utils/smsUtils';

export const SET_PHONE = 'sms/SET_PHONE';
export const SET_CODE = 'sms/SET_CODE';

export const RESET_SMS_STATE = 'sms/RESET_SMS_STATE';

export const EXPIRE_SMS_CODE = 'sms/EXPIRE_SMS_CODE';

export const REQUEST_WITH_SMS_CONFIRMATION = 'sms/REQUEST_WITH_SMS_CONFIRMATION';
export const REQUEST_WITH_SMS_CONFIRMATION_SUCCESS = 'sms/REQUEST_WITH_SMS_CONFIRMATION_SUCCESS';
export const REQUEST_WITH_SMS_CONFIRMATION_FAIL = 'sms/REQUEST_WITH_SMS_CONFIRMATION_FAIL';

export const REQUEST_CONFIRMATION_CODE = 'sms/REQUEST_CONFIRMATION_CODE';
export const REQUEST_CONFIRMATION_CODE_SUCCESS = 'sms/REQUEST_CONFIRMATION_CODE_SUCCESS';
export const REQUEST_CONFIRMATION_CODE_FAIL = 'sms/REQUEST_CONFIRMATION_CODE_FAIL';

export const CLEAN_ERRORS = 'sms/CLEAN_ERRORS';

export const CLEAN_LAST_CODE_REQUEST_TIME = 'sms/CLEAN_LAST_CODE_REQUEST_TIME';

export function setPhone(phone) {
  return {
    type: SET_PHONE,
    phone,
  };
}

export function setCode(code) {
  return {
    type: SET_CODE,
    code,
  };
}

export function resetSmsState(code) {
  return {
    type: RESET_SMS_STATE,
  };
}

export function expireSmsCode(code) {
  return {
    type: EXPIRE_SMS_CODE,
  };
}

export function makeRequestWithSmsConfirmation(url, data, params) {
  return function (dispatch, getState, extraArgument) {
    const { types, options, ...otherParams } = params;
    const { isPhoneConfirmed, phone, code, smsState } = getState().sms;

    dispatch({
      type: REQUEST_WITH_SMS_CONFIRMATION,
      additional: params
    });

    const [t1, t2, t3, t4, t5] = types;

    const smsData = isPhoneConfirmed ?
      (code ? { code } : {}) :
      (code ?
        { code } :
        ((phone && phone.length > 1) ? { phone } : null)
      )
    ;

    const config = {
      types: [t1, [t2, REQUEST_WITH_SMS_CONFIRMATION_SUCCESS, t4].filter(x => !!x), [t3, REQUEST_WITH_SMS_CONFIRMATION_FAIL, t5].filter(x => !!x)],
      apiOptions: { ignore403: true },
      options: {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        ...options,
        body: JSON.stringify({ ...data, sms: smsData }),
      },
      ...otherParams
    };

    const request = makeRequest(url, config);

    return request(dispatch, getState, extraArgument)
      .then(res => {
        const smsResult = res?.sms.result;

        if (isPhoneConfirmed || !(smsState === SMS_STATE_IDLE && smsResult === SMS_RESULT_PHONE_NOT_FOUND)) {
          // если телефон не подтверждён, самый первый запрос штатно вернёт SMS_RESULT_PHONE_NOT_FOUND
          amplitudeSendSmsError(isPhoneConfirmed, smsResult);
        }

        return res;
      })
      .catch(err => {
        const responseStatus = err?.response?.status;

        if (!responseStatus) {
          // полагаем, что ошибка сервера происходит после проверки SMS-кода
          if (isPhoneConfirmed || phone) {
            amplitudeSendSmsError(isPhoneConfirmed, code ? ERROR_CODE_SMS_CODE_CHECK_NETWORK_OR_SERVER_ERROR : ERROR_CODE_SMS_SEND_NETWORK_OR_SERVER_ERROR);
          }
        }

        throw err;
      })
    ;
  };
}

export function requestConfirmationCode() {
  return function (dispatch, getState, extraArgument) {
    const { phone, code, isPhoneConfirmed } = getState().sms;

    const request = makeRequest(`/saduka/sms/sendCode`, {
      types: [REQUEST_CONFIRMATION_CODE, REQUEST_CONFIRMATION_CODE_SUCCESS, REQUEST_CONFIRMATION_CODE_FAIL],
      apiOptions: { ignore403: true },
      options: {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ sms: { phone, code } }),
      },
    });

    return request(dispatch, getState, extraArgument)
      .then(res => {
        amplitudeSendSmsError(isPhoneConfirmed, res?.sms.result);
        return res;
      })
      .catch(err => {
        amplitudeSendSmsError(isPhoneConfirmed, ERROR_CODE_SMS_SEND_NETWORK_OR_SERVER_ERROR);
        throw err;
      })
    ;
  };
}

export function cleanErrors() {
  return {
    type: CLEAN_ERRORS,
  };
}

export function cleanLastRequestTime() {
  return {
    type: CLEAN_LAST_CODE_REQUEST_TIME,
  };
}

export const RESET_CONFIRMED_PHONE = 'sms/RESET_CONFIRMED_PHONE';
export const RESET_CONFIRMED_PHONE_SUCCESS = 'sms/RESET_CONFIRMED_PHONE_SUCCESS';
export const RESET_CONFIRMED_PHONE_FAIL = 'sms/RESET_CONFIRMED_PHONE_FAIL';

export const CONFIRM_PHONE = 'sms/CONFIRM_PHONE';
export const CONFIRM_PHONE_SUCCESS = 'sms/CONFIRM_PHONE_SUCCESS';
export const CONFIRM_PHONE_FAIL = 'sms/CONFIRM_PHONE_FAIL';

export function resetConfirmedPhone() {
  return makeRequestWithSmsConfirmation(
    `/saduka/sms/confirm`,
    {},
    {
      types: [RESET_CONFIRMED_PHONE, null, null, RESET_CONFIRMED_PHONE_SUCCESS, RESET_CONFIRMED_PHONE_FAIL],
      isReset: true,
    }
  );
}

export function confirmPhone() {
  return makeRequestWithSmsConfirmation(
    `/saduka/sms/confirm`,
    {},
    {
      types: [CONFIRM_PHONE, null, null, CONFIRM_PHONE_SUCCESS, CONFIRM_PHONE_FAIL],
    }
  );
}
